<script setup lang="ts">
    import {useI18n} from 'vue-i18n';
    import {ref} from 'vue';
    import useCpBem from '~/composables/useCpBem';
    import CpText from '~/components/cp/CpText/CpText.vue';
    import CpIconEmptyState from '~/components/cp/CpIcon/CpIconEmptyState/CpIconEmptyState.vue';
    import CpButton from '~/components/cp/CpButton/CpButton.vue';
    import {useCpUser} from '~/composables/useCpUser';
    import {usePdp} from '~/stores/detailsStore';
    import CpModalDialog from '~/components/cp/CpModal/CpModalDialog/CpModalDialog.vue';

    defineProps<{
      noQuestions?: boolean
    }>();
    const store = usePdp();
    const showModalRequieredLogin = ref(false);
    const {isAuthenticated} = useCpUser();
    const isAuth = () => {
      if (isAuthenticated.value) {
        // TODO: Change the URL
        navigateTo({name: 'details-ask-question', params: {id: store.getProductId}});
      } else {
        showModalRequieredLogin.value = true;
      }
    };
    function showModalLogin() {
      showModalRequieredLogin.value = false;
      useEvent('show-login-modal', {show: true, route: 'details-ask-question', params: {id: store.getProductId}});
    }
    const {b, e} = useCpBem('cp-card-redirect-qna');
    const {t} = useI18n();
</script>

<template>
    <div :class="b">
        <CpModalDialog
            v-model:show="showModalRequieredLogin"
            :title="t('warning')"
            :body="t('forYouCanWrite')"
            :label-first-button="t('login')"
            type-first-button="primary"
            @first-button="showModalLogin()"
        />
        <div :class="e`title`">
            <CpText v-if="noQuestions" variant="heading-h3-fake">
                {{ t('noQuestions') }}
            </CpText>
            <CpText v-else variant="heading-h3-fake">
                {{ t('findQuestion') }}
            </CpText>
        </div>
        <div :class="e`message-box`">
            <CpIconEmptyState icon="live_help" />
            <CpText variant="body-regular">
                {{ t('noQuestionText') }}
            </CpText>
        </div>
        <div :class="e`cta`">
            <CpButton
                :label="t('ask')"
                data-testid="btn-ask-question"
                :href="isAuthenticated ? store.getProduct?.questionsLink?.replace('https://www.cyberpuerta.mx', '') : undefined"
                kind="label"
                type="button"
                full-width
                color="primary"
                @click="isAuth"
            />
        </div>
    </div>
</template>

<style scoped lang="scss">
    .cp-card-redirect-qna {
        border: 1px solid var(--color-neutral-extra-light);
        border-radius: 8px;
        &__title {
          padding: 16px;
          border-bottom: 1px solid var(--color-neutral-extra-light);
        }
        &__message-box {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          gap: 16px;
          padding: 16px;
          border-bottom: 1px solid var(--color-neutral-extra-light);
        }
        &__cta {
          padding: 16px;
        }
    }
</style>

<i18n locale="es-US" lang="yaml">
  warning: 'Aviso'
  forYouCanWrite: 'Para que puedas hacer una pregunta es necesario que inicies sesión.'
  login: 'Iniciar sesión'
  ask: "Hacer una pregunta"
  findQuestion: "¿No encuentras la respuesta a tu duda?"
  noQuestions: "Aún no hay preguntas acerca de este producto"
  noQuestionText: "Resuelve tus dudas preguntando a la comunidad y a nuestro Centro de Servicio al Cliente."
</i18n>
